import React, { useRef, useState } from 'react';
import { CoreTracking } from '../../../models/CoreTracking';
import { Link } from 'react-router-dom';
import Copy from '../../misc/Copy';

interface ITrackingNavigation {
        Tracking : CoreTracking
}

const TrackingsNavigation: React.FC<ITrackingNavigation> = (props: ITrackingNavigation) =>
{
    interface SourceObjectTypes {
        [key: string]: string;
    }
    const oneRosterMappingSourceObjectTypes: SourceObjectTypes = {
        Organisation: 'schoolunit',
        StudentUser: 'user',
        StaffUser: 'user',
        Class: 'class',
        SchoolUnit: 'schoolunit'
    }
    enum TrackingSourceName { 
        OneRoster = "OneRoster", 
    }

    const createPath = (tracking: CoreTracking, sourceName: string) => {
        let path = ''; 
        switch (sourceName) {
            case TrackingSourceName.OneRoster: {
                let pathObjectType = '';
                if (tracking.sourceObjectType in oneRosterMappingSourceObjectTypes) {
                    pathObjectType = oneRosterMappingSourceObjectTypes[tracking.sourceObjectType]
                }
                return path = pathObjectType === '' ? '' : `/oneroster/${pathObjectType}/${tracking.sourceSystemId}/information`
            }
        }
        return path
    }

    const renderSourceSystemId = (tracking: CoreTracking) => {
        let path = createPath(tracking, tracking.sourceName);
        if (path.length > 0) {
            let link = (<Link key={tracking.trackingId} to={path}>{tracking.sourceSystemId}</Link>);

            return <span>{link}<Copy value={tracking.sourceSystemId} /></span>
        }

        return <span> {tracking.sourceSystemId} <Copy value={tracking.sourceSystemId} /> </span> 
    }

    return <div> {renderSourceSystemId(props.Tracking)}</div>    
}

export default TrackingsNavigation; 
